var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status==='active')?_c('span',{staticClass:"legend-indicator bg-success"}):(_vm.status==='suspended')?_c('span',{staticClass:"legend-indicator bg-warning"}):_c('span',{staticClass:"legend-indicator bg-danger"})])
}
var staticRenderFns = []

export { render, staticRenderFns }